import { render, staticRenderFns } from "./ContentBlockFlashcard.vue?vue&type=template&id=07c764e3&"
import script from "./ContentBlockFlashcard.vue?vue&type=script&lang=js&"
export * from "./ContentBlockFlashcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports